import React, { useEffect, useState } from "react";
import { Avatar, Badge, Button, Divider, List, Popover, Tooltip, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";

import { get_api_function } from '@/utils/api';
import { defaultColors } from '@/themes/antd-theme';
import { useResponsive } from '@/hooks/useResponsive';
import { useTheme } from '@/App';

const deviation_color = () => {
  return {
    color: defaultColors.warning,
    bg_color: '#fff5e6'
  };
};

// ==============================|| HEADER CONTENT - ALERT NOTIFICATION ||============================== //

const AlertNotification = () => {
  const { isDark } = useTheme();
  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [notificationsData, setNotificationsData] = useState([]);

  useEffect(() => {
    const fetchNotifications = () => {
      get_api_function(
        "/get_operation_alert",
        (res) => {
          setNotificationsData(res?.data?.data || []);
        },
        undefined  // No params needed for this endpoint
      );
    };

    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 60000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const popoverContent = (
    <div style={{ width: isMobile ? 285 : 420, maxHeight: 500, overflowY: 'auto' }}>
      <List
        dataSource={notificationsData?.slice(0, 4)}
        renderItem={(item, index) => (
          <React.Fragment key={index}>
            <List.Item className="py-2">
              <div className="flex w-full gap-3">
                <Avatar
                  size={36}
                  style={{
                    color: deviation_color()?.color,
                    backgroundColor: deviation_color()?.bg_color,
                    flexShrink: 0
                  }}
                >
                  {item.operation_name
                    .split(" ")
                    ?.slice(0, 2)
                    .map((word) => word[0])
                    .join("")
                    .toUpperCase()}
                </Avatar>
                <div className="flex-1 min-w-0">
                  <Typography.Paragraph
                    ellipsis={{
                      rows: 2,
                      expandable: true,
                      symbol: "more",
                    }}
                    className="mb-2"
                  >
                    {item?.msg}
                  </Typography.Paragraph>
                  <div className="text-xs" style={{ color: defaultColors.text.secondary }}>
                    <div>Batch: {item?.batch_number}</div>
                    <div>Operation Name: {item?.operation_name}</div>
                    <div>Duration: {item?.duration}</div>
                    <div>Running Time: {item?.running_time}</div>
                  </div>
                </div>
                <div className="flex flex-col items-end text-xs" style={{ color: defaultColors.text.secondary }}>
                  <div>{item?.batch_schedule_time?.slice(0, 10)}</div>
                  <div>{item?.batch_schedule_time?.slice(11, 19)}</div>
                </div>
              </div>
            </List.Item>
            <Divider className="my-0" />
          </React.Fragment>
        )}
      />
      <Divider />
      <div className="text-center py-3">
        <Button
          type="link"
          onClick={() => {
            navigate("/alert-notify");
            setOpen(false);
          }}
        >
          <h6 className="text-lg font-semibold m-0" style={{ color: defaultColors.primary }}>
            View All
          </h6>
        </Button>
      </div>
    </div>
  );

  // Dark mode aware colors
  const bgColor = isDark
    ? (open ? defaultColors.grey[600] : defaultColors.grey[700])
    : (open ? defaultColors.grey[300] : defaultColors.grey[100]);
  const iconColor = isDark ? defaultColors.grey[100] : defaultColors.grey[700];

  return (
    <Popover
      content={popoverContent}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement={isMobile ? "bottom" : "bottomRight"}
    >
      <Tooltip title="Alert Notification" zIndex={9999}>
        <Button
          type="text"
          shape="circle"
          icon={
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Badge count={notificationsData?.length} size="small">
                <WarningOutlined style={{ fontSize: 23, display: 'block', color: iconColor }} />
              </Badge>
            </div>
          }
          style={{
            backgroundColor: bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
        />
      </Tooltip>
    </Popover>
  );
};

export default AlertNotification;
